import { apiRequest } from "./client";

export type UploadImageResponse = {
	name: string;
	url: string;
};

/** Uploads an image to blob storage and returns its public URL + stored blob name. */
export const uploadImage = (file: File, prefix: string, token: string): Promise<UploadImageResponse> => {
	const formData = new FormData();
	formData.append("File", file);
	formData.append("Prefix", prefix);

	return apiRequest<UploadImageResponse>("/images", { method: "POST", body: formData, token });
};
